import { Box } from '@mui/material'

import { ModalContent } from '@/components/Modal'

import { useConfigureController } from '../hooks/useController'

import { Footer } from './Footer'
import { Header } from './Header'
import { Body } from './Body/Body'

type Props = {
  userIds: string[]
}

export function Content(props: Props) {
  const { ready } = useConfigureController(props.userIds)

  if (!ready) return null

  return (
    <ModalContent header={<Header />} footer={<Footer />}>
      <Box paddingTop={2} maxWidth={400}>
        <Body />
      </Box>
    </ModalContent>
  )
}
